"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LOCATION_STATUS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

var _geo = require("../../utils/geo");

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LOCATION_STATUS = {
  IDLE: 0,
  WAITING_FOR_USER_LOCATION: 1,
  CALCULATING_DIST: 2,
  FINISHED: 3,
  LOCATION_UNAVAILABLE: 4
};
exports.LOCATION_STATUS = LOCATION_STATUS;

var GeoClosestLocation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(GeoClosestLocation, _React$Component);

  var _super = _createSuper(GeoClosestLocation);

  function GeoClosestLocation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, GeoClosestLocation);
    _this = _super.call(this, props);

    _reactGeocode["default"].setApiKey(process.env.GOOGLE_MAPS_API_KEY);

    if (process.env.NODE_ENV === 'development') {
      _reactGeocode["default"].enableDebug();
    }

    _this.state = {
      locationStatus: LOCATION_STATUS.IDLE,
      locationsWithDistance: props.locations.map(function (l) {
        return _objectSpread({}, l, {
          fullAddress: GeoClosestLocation.getFullAddress(l)
        });
      })
    };
    _this.isLoading = _this.isLoading.bind((0, _assertThisInitialized2["default"])(_this));
    _this.hasUsersLocation = _this.hasUsersLocation.bind((0, _assertThisInitialized2["default"])(_this));
    _this.doesNotHaveUsersLocation = _this.doesNotHaveUsersLocation.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(GeoClosestLocation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var start = this.props.start;

      if (start) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var oldStart = prevProps.start;
      var newStart = this.props.start;
      var locationStatus = this.state.locationStatus;

      if (newStart && !oldStart && locationStatus === LOCATION_STATUS.IDLE) {
        this.getUsersLocation();
      }
    }
  }, {
    key: "getUsersLocation",
    value: function getUsersLocation() {
      if ("geolocation" in navigator) {
        this.setState({
          locationStatus: LOCATION_STATUS.WAITING_FOR_USER_LOCATION
        });
        navigator.geolocation.getCurrentPosition(this.hasUsersLocation, this.doesNotHaveUsersLocation);
      } else {
        this.setState({
          locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
        });
      }
    }
  }, {
    key: "doesNotHaveUsersLocation",
    value: function doesNotHaveUsersLocation() {
      this.setState({
        locationStatus: LOCATION_STATUS.LOCATION_UNAVAILABLE
      });
    }
  }, {
    key: "hasUsersLocation",
    value: function () {
      var _hasUsersLocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(position) {
        var _this$props, locations, distanceUnit, userLat, userLong, locationsWithDistance, _iterator, _step, location, fullAddress, distance, results, _results$results$0$ge, lat, lng;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, locations = _this$props.locations, distanceUnit = _this$props.distanceUnit;
                this.setState({
                  locationStatus: LOCATION_STATUS.CALCULATING_DIST
                });
                userLat = position.coords.latitude;
                userLong = position.coords.longitude;
                locationsWithDistance = [];
                _iterator = _createForOfIteratorHelper(locations);
                _context.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context.next = 24;
                  break;
                }

                location = _step.value;
                fullAddress = GeoClosestLocation.getFullAddress(location);
                distance = -1;
                _context.prev = 12;
                _context.next = 15;
                return _reactGeocode["default"].fromAddress(fullAddress);

              case 15:
                results = _context.sent;

                if (results) {
                  _results$results$0$ge = results.results[0].geometry.location, lat = _results$results$0$ge.lat, lng = _results$results$0$ge.lng;
                  distance = (0, _geo.calculateDistance)(lat, lng, userLat, userLong, distanceUnit);
                }

                _context.next = 21;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](12);

              case 21:
                locationsWithDistance.push(_objectSpread({}, location, {
                  fullAddress: fullAddress,
                  distance: distance,
                  distanceUnit: distanceUnit
                }));

              case 22:
                _context.next = 8;
                break;

              case 24:
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context["catch"](6);

                _iterator.e(_context.t1);

              case 29:
                _context.prev = 29;

                _iterator.f();

                return _context.finish(29);

              case 32:
                ;
                locationsWithDistance.sort(function (a, b) {
                  if (a.distance === -1) return 1;
                  if (b.distance === -1) return -1;
                  return a.distance > b.distance ? 1 : -1;
                });
                this.setState({
                  locationStatus: LOCATION_STATUS.FINISHED,
                  locationsWithDistance: locationsWithDistance
                });

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 26, 29, 32], [12, 19]]);
      }));

      function hasUsersLocation(_x) {
        return _hasUsersLocation.apply(this, arguments);
      }

      return hasUsersLocation;
    }()
  }, {
    key: "isLoading",
    value: function isLoading() {
      var ls = this.state.locationStatus;
      return ls === LOCATION_STATUS.WAITING_FOR_USER_LOCATION || ls === LOCATION_STATUS.CALCULATING_DIST;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          locationStatus = _this$state.locationStatus,
          locationsWithDistance = _this$state.locationsWithDistance;
      var children = this.props.children;
      return children({
        state: locationStatus,
        locations: locationsWithDistance,
        isLoading: this.isLoading()
      });
    }
  }], [{
    key: "getFullAddress",
    value: function getFullAddress(location) {
      return "".concat(location.street, ", ").concat(location.city, ", ").concat(location.state, " ").concat(location.zip);
    }
  }]);
  return GeoClosestLocation;
}(_react["default"].Component);

exports["default"] = GeoClosestLocation;
GeoClosestLocation.propTypes = {
  start: _propTypes["default"].bool,
  distanceUnit: _propTypes["default"].oneOf(["M", "K"]),
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    city: _propTypes["default"].string,
    state: _propTypes["default"].string,
    street: _propTypes["default"].string,
    zip: _propTypes["default"].string
  }))
};
GeoClosestLocation.defaultProps = {
  start: false,
  distanceUnit: "M",
  locations: []
};